(function() {
  'use strict';

  var lastItemCount = null;
  var checkTimeout = null;

  function fireNorthbeamATC() {
    if (typeof window.Northbeam === 'undefined' || typeof window.Northbeam.fireCustomGoal !== 'function') {
      setTimeout(fireNorthbeamATC, 500);
      return;
    }

    try {
      window.Northbeam.fireCustomGoal('add_to_cart', {});
    } catch (e) {}
  }

  function checkCart() {
    if (checkTimeout) return;
    checkTimeout = setTimeout(function() {
      checkTimeout = null;
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (lastItemCount !== null && cart.item_count > lastItemCount) {
            fireNorthbeamATC();
          }
          lastItemCount = cart.item_count;
        })
        .catch(function() {});
    }, 300);
  }

  checkCart();

  document.addEventListener('cart:updated', checkCart);
  document.addEventListener('cart-update', checkCart);
  document.addEventListener('cartdrawer:opened', checkCart);

  var miniCart = document.querySelector('mini-cart');
  if (miniCart) {
    new MutationObserver(checkCart).observe(miniCart, { childList: true, subtree: true });
  }
})();
